import gql from 'graphql-tag';

export const EDIT_SURVEY = gql`
mutation updateSurvey($description: String, $termsConditions: String, $id: ID!, $name: String, $organizations: [Int], $teams: [Int], $verticals: [Int], $activeFrom: DateTime, $activeTo: DateTime, $public: Boolean, $shuffle: Boolean, $reportQuery: String) {
  updateSurvey(description: $description, termsConditions: $termsConditions, id: $id, name: $name, organizations: $organizations, teams: $teams, verticals: $verticals, shuffle: $shuffle, public: $public, activeFrom: $activeFrom, activeTo: $activeTo, reportQuery: $reportQuery) {
    survey {
      id
      name
      reportQuery
      description
      termsConditions
      shuffle
      public
      multisourceResponse
      activeFrom
      activeTo
      reportAvailable
      pubDate
      organization {
        edgeCount
        edges {
          node {
            id
            name
            description
            email
            logo
            termsConditions
            allowComparison
          }
        }
      }
      vertical {
        edgeCount
        edges {
          node {
            id
            name
            organization {
              id
              name
            }
          }
        }
      }
      team {
        edgeCount
        edges {
          node {
            id
            id
            name
            description
            vertical {
              id
              organization {
                id
                name
              }
            }
          }
        }
      }
      groupSet {
        totalCount
        pageInfo {
          hasNextPage
          endCursor
        }
        edges {
          node {
            id
            name
            label
            helpText
            sequence
            matrix
            showInResult
            showAvgInResult
            questionSet {
              edges {
                node {
                  id
                  questionText
                  questionAddress
                  helpText
                  sequence
                  numberOfAnswers
                  pubDate
                  required
                  url
                  mediaType
                  gradingParameters
                  choiceSet {
                    totalCount
                    edges {
                      node {
                        id
                        label
                        value
                        sequence
                        inputType
                        answerKey
                      }
                    }
                  }
                  answerSet {
                    totalCount
                    edges {
                      node {
                        id
                        answer
                        sequence
                        gradingParametersAnswers
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;



export const EDIT_SURVEY_ADMIN_PANEL = gql`
  mutation updateSurvey(
    $description: String
    $termsConditions: String
    $id: ID!
    $name: String
    $organizations: [Int]
    $teams: [Int]
    $verticals: [Int]
    $activeFrom: DateTime
    $activeTo: DateTime
    $public: Boolean
    $shuffle: Boolean
    $reportQuery: String
  ) {
    updateSurvey(
      description: $description
      termsConditions: $termsConditions
      id: $id
      name: $name
      organizations: $organizations
      teams: $teams
      verticals: $verticals
      shuffle: $shuffle
      public: $public
      activeFrom: $activeFrom
      activeTo: $activeTo
      reportQuery: $reportQuery
    ) {
      survey {
        id
        name
      }
    }
  }
`;